export const Toast = 'atlantis-toast';
export const ToastMessage = 'atlantis-toast-message';
